<template>
  <v-card>
    <v-card-text>Colour List</v-card-text>
    <List />
    <Edit />
    <New />

    <v-btn
      @click="enableAddModal()"
      fixed
      depressed
      dark
      fab
      bottom
      right
      color="primary"
      :style="$root.rightNav?'margin-right:260px; margin-bottom:30px;':'margin-bottom:30px;'"
    >
      <v-icon dark>add</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import List from './List.vue'
import Edit from './Edit.vue'
import New from './New.vue'
export default {
  components: {
    List,
    Edit,
    New
  },
  data() {
    return {
      tab: 0
    }
  },
  computed: {
    ...mapGetters({
      editModal: 'color/editPop',
      addModal: 'color/addPop'
    })
  },
  methods: {
    enableAddModal() {
      this.setAddPop(true)
    },
    ...mapActions({
      setAddPop: 'color/setAddPop'
    })
  }
}
</script>
